const setMethods = (model) => {
  model.venueImageUrl = () => {
    // sample method, not tested
    if (model.venue) {
      return model.venue && model.venue.photos && model.venue.photos.length
        ? model.venue.photos[0].imageURL
        : null;
    }
    return null;
  };
};
export default setMethods;
